import { Group, ActionIcon, Text } from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import Link from "next/link";

import { EXPLORER_PAGE_SIZE } from "constants/explorer_selection_options";
import { useSearchRouteInfo } from "hooks/routing";

interface ExplorerPaginationControlsProps {
  resultsLength: number;
  numTotalResults: number;
  resultsOffset: number;
}

export function ExplorerPaginationControls({
  resultsLength,
  numTotalResults,
  resultsOffset,
}: ExplorerPaginationControlsProps) {
  const noResults = resultsLength === 0;

  const prevOffset = Math.max(resultsOffset - EXPLORER_PAGE_SIZE, 0);
  const nextOffset = resultsLength + resultsOffset;

  const routeInfo = useSearchRouteInfo();

  return (
    <Group justify="center">
      <ActionIcon
        component={Link}
        href={updateOffsetParam(routeInfo.baseRoute, routeInfo.queryString, prevOffset)}
        c="gray.5"
        disabled={resultsOffset < 1}
      >
        <IconChevronLeft size={20} />
      </ActionIcon>
      {noResults ? (
        <Text c="gray.5" size="sm">
          {"0 of 0"}
        </Text>
      ) : (
        <Text c="gray.5" size="sm">{`${resultsOffset + 1} - ${
          resultsOffset + resultsLength
        } of ${numTotalResults}`}</Text>
      )}
      <ActionIcon
        component={Link}
        href={updateOffsetParam(routeInfo.baseRoute, routeInfo.queryString, nextOffset)}
        c="gray.5"
        disabled={resultsOffset + resultsLength === numTotalResults || noResults}
      >
        <IconChevronRight size={20} />
      </ActionIcon>
    </Group>
  );
}

function updateOffsetParam(
  basePath: string,
  queryString: string | undefined,
  offset: number,
): string {
  let searchParams = new URLSearchParams(queryString);

  if (offset === 0 || offset === undefined || offset === null) {
    searchParams.delete("offset");
  } else {
    searchParams.set("offset", offset.toString());
  }

  return `${basePath}/${searchParams.toString()}`;
}
